import React from "react";
import { Grid, Typography, styled } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[2],
    padding: theme.spacing(1),
    maxHeight:270,
    minWidth: "80%", // Increase the width to 80% of the container
  },
  title: {
    fontWeight: "bold",
    color: theme.palette.primary.main,
  },
}));
const Row = styled(Grid)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(1.5),
  marginBottom: theme.spacing(1),
  "&:hover": {
    backgroundColor: theme.palette.action.hover,
  },
  display: 'flex',
  alignItems: 'center',
}));

const OrderReceipt = ({ order }) => {
  const classes = useStyles();

  return (
    <Grid container spacing={1} direction="column">
      {/* Order ID Row */}
      <Row item>
        <Grid item xs={4} sx={{ minWidth: '120px' }}>
          <Typography variant="body1" fontWeight="bold" className={classes.title} noWrap>
            Order Id
          </Typography>
        </Grid>
        <Grid item xs={8} sx={{ minWidth: 0 }}>
          <Typography 
            color="textSecondary"
            noWrap
            sx={{ 
              textOverflow: 'ellipsis',
              overflow: 'hidden'
            }}
          >
            {order?.orderId ? order.orderId : order.id}
          </Typography>
        </Grid>
      </Row>

      {/* Order Date Row */}
      <Row item>
        <Grid item xs={4} sx={{ minWidth: '120px' }}>
          <Typography variant="body1" fontWeight="bold" className={classes.title} noWrap>
            Order Date
          </Typography>
        </Grid>
        <Grid item xs={8} sx={{ minWidth: 0 }}>
          <Typography 
            color="textSecondary"
            noWrap
          >
            {new Date(order?.updatedAt).toLocaleDateString("en-US", {
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
          </Typography>
        </Grid>
      </Row>

      {/* Order Status Row */}
      <Row item>
        <Grid item xs={4} sx={{ minWidth: '120px' }}>
          <Typography variant="body1" fontWeight="bold" className={classes.title} noWrap>
            Order Status
          </Typography>
        </Grid>
        <Grid item xs={8} sx={{ minWidth: 0 }}>
          <Typography 
            color="textSecondary"
            noWrap
            sx={{ 
              textOverflow: 'ellipsis',
              overflow: 'hidden'
            }}
          >
            {order?.status}
          </Typography>
        </Grid>
      </Row>

      {/* Assigned To Row */}
      <Row item id="ttt">
        <Grid item xs={4} sx={{ minWidth: '120px' }}>
          <Typography variant="body1" fontWeight="bold" className={classes.title} noWrap>
            Assigned To
          </Typography>
        </Grid>
        <Grid item xs={8} sx={{ minWidth: 0 }}>
          <Typography 
            color="textSecondary"
            noWrap
            sx={{ 
              textOverflow: 'ellipsis',
              overflow: 'hidden'
            }}
          >
            {order?.staff?.fullName}
          </Typography>
        </Grid>
      </Row>
    </Grid>
  );
};

export default OrderReceipt;